import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Avatar
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import NotificationBar from "./NotificationBar";
import { useDispatch, useSelector } from "react-redux";
import LanguageSwitcher from "./LanguageSwitcher";
import { Modal } from "@material-ui/core";
import {
  useStyles as useStylesForSdk,
  useTranslations,
} from "examsbook-react-sdk/custom-hooks";
import NotificationScreen from "../../PaymentSection/NotificationScreen";
import "./Header.scss";
import { useSearchQuery } from "../../../services/SearchQueryContext";
import { ReactComponent as SearchIcon } from "../../../assets/images/search.svg";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import MobileViewSideBar from "./MobileViewSideBar";
import { ReactComponent as CrossIcon } from "../../../assets/images/close.svg";
import { useTheme } from "../../../constants/themeProvider";
import Tooltip from "@material-ui/core/Tooltip";
import BrandLogo from "../../../assets/images/LearnifyLogoLight.png";
import NotificationsIcon from '@material-ui/icons/Notifications';
import status from "examsbook-react-sdk/constants/actionStatus.js";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { LinearProgressWithLabel } from "../../Tabs/SelfLearningCard";
import { setSelfLearningTabAction } from "examsbook-react-sdk/actions/getCourses";
import { getSelfLearningAction } from "examsbook-react-sdk/actions/getSelfLearningAction";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    appBar: {
      width: "100%",
    },
  },

  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },

  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },

  hide: {
    display: "none",
  },

  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}));
const drawerWidth = 300;
function CHeaderBarContent(props) {
  const {
    open,
    openFeedbackModel,
  } = props;
  const t = useTranslations();
  const user = useSelector((state) => state.user);
  const userName = user?.user?.name ? user?.user?.name : user?.name;
  const userImage = user?.user?.image ? user?.user?.image : user?.image;
  const theme = useTheme();

  const [refresh, setRefresh] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [mySectionData, setMySectionData] = useState("");
  const { searchQuery, setSearchQuery } = useSearchQuery();
  const [isMobile, setIsMobile] = useState(false);
  const [openToggler, setOpenToggler] = useState(false);
  const [dynamicLogos, setDynamicLogos] = useState('');
  const settings = useSelector((state) => state.settingsReducers);
  const isLoadingSettings = settings.status === status.PENDING;
  const settingsData = settings.settingsData?.data || [];

  const toggleDrawer = (isOpen) => {
    setOpenToggler(isOpen);
  };

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 959);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  let learningData = useSelector((state) => state.selfLearningReducers);
  let selfLearningData = learningData.selfLearningData;
  const courseName = useSelector(state => state.filteredCourseList.courseName) || location?.state?.courseName || location?.state?.subjectDetail?.courseId?.name || mySectionData?.data?.courseId?.name;
  const showEvaluationTest = useSelector(state => state.filteredCourseList.showEvaluationTest) || location?.state?.showEvaluationTest;
  const showInstructions = useSelector(state => state.filteredCourseList.showInstructions) || location?.state?.showInstructions;
  const isVisible = useSelector((state) => state?.bottomBarReducer?.isVisible);
  const filterCourseId = location.pathname.split('/');
  const courseIdFromLocation = filterCourseId[filterCourseId.length - 1];
  const courseId = useSelector(state => state.filteredCourseList.courseId) || location?.state?.courseId || courseIdFromLocation;
  const savedMenu = localStorage.getItem('selectedMenu');
  const courseProgress = useSelector(state => state.filteredCourseList.courseProgress) || selfLearningData?.data?.progressPercent || location?.state?.courseProgress;

  useEffect(() => {
    if(isMobile && showEvaluationTest !==undefined && courseIdFromLocation && showEvaluationTest) {
      dispatch(getSelfLearningAction(courseIdFromLocation)).then((res) => {
        setMySectionData(res);
      });
    }
  }, [courseIdFromLocation, showEvaluationTest]);

  useEffect(() => {
    if (!isLoadingSettings) {
    const imageValue = settingsData?.data?.[0]?.branding?.logos?.webAndAppLogo?.imagePath;
    setDynamicLogos(imageValue ? imageValue : BrandLogo);
    }
  }, [isLoadingSettings, settingsData])

  const handleMenu = () => {
    history.push("/my-profile");
  };

  const handleClose = () => {
    setOpenModal(false);
    setRefresh(!refresh);
  };

  const goToCourse = () => {
    history.push(`/course/${courseId}`, {courseId:courseId, subjectId: '', topicId:'', subjectDetail:'', subjectName:'', topicName:'', courseName: courseName, showEvaluationTest: showEvaluationTest, showInstructions: showInstructions, courseProgress: courseProgress });
  }
  const classesList = useStylesForSdk(styles)();

  const [currentTime, setCurrentTime] = useState(new Date());
  const hour = currentTime.getHours();

  let greeting = `${t("Good Morning")}`;
  if (hour >= 12 && hour < 16) {
    greeting = `${t("Good Afternoon")}`;
  } else if (hour >= 16) greeting = `${t("Good Evening")}`;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  function clearField(searchQuery) {
    if (searchQuery.length) setSearchQuery("");
  }

  const handleNavigation = () => {
    history.push("/dashboard");
  };

  function goToCourseScreen() {
    if(savedMenu === "/courses") {
      history.push("/courses");
    } else {
      history.push('/my-courses', { params: window.location.pathname});
    }
  }

  const goBack = () => {
    dispatch(setSelfLearningTabAction(true));
    if (/^\/reports\/[^/]+\/[^/]+$/.test(window.location.pathname)) {
      goToCourse();
    }
  }

  return (
    <Toolbar
      disableGutters={!open}
      className="main-header-section"
      id="mainHeaderSectionId"
      style={{display: 'flex', boxShadow: isMobile && 'none'}}
    >
      {isMobile ? (
        <>
          <AppBar style={{ width: "100%", background: theme?.primaryColor, boxShadow: isMobile && 'none' }}>
            <Toolbar
              style={{ display: "flex" }}
            > 
              <Box style={{ display: "flex", alignItems: "center" }}>
                {!isVisible && !/^\/reports\/[^/]+\/[^/]+$/.test(window.location.pathname) ? 
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  onClick={() => toggleDrawer(true)}
                >
                  <MenuIcon />
                </IconButton> 
                : (
                <ArrowBackIcon style={{ cursor: "pointer" }} onClick={() => goBack()}/>)}
              </Box>

              <Box className="text-box-mobile">
                <Typography
                  className="greeting-text-mobile"
                >
                  {greeting}, <Typography variant="inherit">{userName}</Typography>
                </Typography>
              </Box>
             {/^\/reports\/[^/]+\/[^/]+$/.test(window.location.pathname) ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <Typography key="tabLabel" variant="inherit" color="inherit" style={{fontSize: '18px', fontWeight: 500}}>
                    <Tooltip title={courseName} aria-label="add">
                      <Typography variant="inherit">{courseName}</Typography>
                    </Tooltip>
                  </Typography>
                </Box>
              ) : window.location.pathname === "/courses" ? (
                <Typography className="greeting-text-mobile">
                  {t("All Courses")}
                </Typography>
              ) : window.location.pathname === "/my-courses" ? (
                <Typography className="greeting-text-mobile">
                  {t("My Courses")}
                </Typography>
              ) : window.location.pathname === "/surveys" ? (
                <Typography className="greeting-text">
                  {t("Surveys")}
                </Typography>
              ) : window.location.pathname === "/support" ? (
                <Typography className="greeting-text">
                  {t("New Support Ticket")}
                </Typography>
                ) : window.location.pathname === "/support-ticket" ? (
                  <Typography className="greeting-text">
                    {t("Support Ticket")}
                  </Typography>
                ) : window.location.pathname === `/course/leaderboard/${courseId}` ? (
                  <Typography className="greeting-text-mobile">
                    {t("Leaderboard")}
                  </Typography>
                ) : window.location.pathname === "/certificate-list" ? (
                <Typography className="greeting-text">
                  {t('My Certificates')}
                </Typography> 
              ): window.location.pathname === "/notifications" ? (
                <Typography className="greeting-text">
                  {t("Notifications")}
                </Typography> 
              ) : window.location.pathname === "/my-profile" ? (
                <Typography className="greeting-text-mobile">
                  {t("my_profile")}
                </Typography> 
              ) : !isVisible && window.location.pathname !== "/dashboard" ? (
                <Typography className="greeting-text-mobile" variant="inherit" color="inherit" style={{ cursor: "pointer", marginLeft: '0px' }} onClick={() => goToCourseScreen()}>
                  {savedMenu === "/courses" ? t("All Courses") : t("MY_COURSES")} 
                </Typography>                                  
              ) : (
                !isLoadingSettings && dynamicLogos && !isVisible && <Box component="img" src={dynamicLogos} className="brand-header-logo" onClick={() => handleNavigation()} />
              )}
              {!isVisible ? (
                <Box className="mobile-notification-screen">
                  {!/^\/reports\/[^/]+\/[^/]+$/.test(window.location.pathname) && 
                  <IconButton onClick={() => history.push("/notifications")}>
                    <NotificationsIcon />
                  </IconButton>}
                </Box>
              ) : (
                <Box className={classesList.headerCourseNameBox}>
                  <Typography className="greeting-course-name ellipsis-course-name">
                    {courseName}
                  </Typography>
                  <Box style={{ fontWeight: 500, color: '#fff', fontSize: isMobile && '14px', width: isMobile && 'max-content'}}>
                    <LinearProgressWithLabel value={courseProgress}/>
                  </Box>
                </Box>
              )}
              <Box style={{ display: isMobile ? "none" : "none" }}>
                <IconButton
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  <Avatar
                    src={userImage}
                    alt="user image"
                    className="my-image"
                    style={{borderRadius:'180px', height:'50px', width:'50px', backgroundColor: !userImage ? theme?.primaryColor : undefined}}
                  />
                  <Box id="contentBlockId" style={{paddingLeft: '10px', flex: 'none', display: isMobile ? "none" : "block"}}>
                    <p id="contentId">{userName}</p>
                  </Box>
                </IconButton>
              </Box>
            </Toolbar>
          </AppBar>
          <MobileViewSideBar
            openToggler={openToggler}
            toggleDrawer={toggleDrawer}
            openFeedbackModel={openFeedbackModel}
            classes={classes}
            user={user}
          />
        </>
      ) : (
        <>
        <Box className="text-box" style={{display: 'flex', alignItems: 'center', gap: '30px'}}>
          {/^\/reports\/[^/]+\/[^/]+$/.test(window.location.pathname) ? (
            <Box className={classesList.reportsHeader}>
              <ArrowBackIcon style={{ cursor: "pointer" }} onClick={() => goBack()}/>
              <Typography key="tabLabel" variant="inherit" color="inherit" className={classesList.courseNameText}>
                <Tooltip title={courseName} aria-label="add">
                  <Typography variant="inherit">{courseName}</Typography>
                </Tooltip>
              </Typography>
            </Box>
          ) : window.location.pathname === "/courses" ? (
            <Typography className="greeting-text">
              {t("All Courses")}
            </Typography>
          ) : window.location.pathname === "/my-courses" ? (
            <Typography className="greeting-text">
              {t("My Courses")}
            </Typography>
          ) : window.location.pathname === "/surveys" ? (
            <Typography className="greeting-text">
              {t("Surveys")}
            </Typography>
          ) : window.location.pathname === "/support" ? (
            <Typography className="greeting-text">
              {t("New Support Ticket")}
            </Typography>
            ) : window.location.pathname === "/support-ticket" ? (
              <Typography className="greeting-text">
                {t("Support Ticket")}
              </Typography>
            ) : window.location.pathname === `/course/leaderboard/${courseId}` ? (
              <Typography className="greeting-text">
                {t("Leaderboard")}
              </Typography>
            ) : window.location.pathname === "/certificate-list" ? (
            <Typography className="greeting-text">
              {t('My Certificates')}
            </Typography> 
          ): window.location.pathname === "/notifications" ? (
            <Typography className="greeting-text">
              {t("Notifications")}
            </Typography> 
          ) : window.location.pathname === "/my-profile" ? (
            <Typography className="greeting-text">
              {t("my_profile")}
            </Typography> 
          ) : (
            <Typography className="greeting-text">
              {greeting}, <Typography variant="inherit">{userName}</Typography>
            </Typography>
          )}

          {(window.location.pathname === "/courses" || window.location.pathname === "/surveys" || window.location.pathname === "/support-ticket" || window.location.pathname === "/my-courses" || window.location.pathname === "/certificate-list") && (
              <Box className="outer-search-box">
                <input
                  className="search-box"
                  style={{ border: "none" }}
                  type="text"
                  placeholder={t('Search')}
                  value={searchQuery}
                  onChange={(event) => setSearchQuery(event.target.value)}
                />
                <Box className="search-img-box">
                  {searchQuery.length ? (
                    <button
                      onClick={() => clearField(searchQuery)}
                      style={{ border: "none" }}
                    >
                      <CrossIcon className="cross-icon" alt="Cross Icon" />
                    </button>
                  ) : (
                    <SearchIcon className="search-icon" alt="Search Icon" />
                  )}
                </Box>
              </Box>
          )}
        </Box>
          {!/^\/reports\/[^/]+\/[^/]+$/.test(window.location.pathname) && <Box className="notification-bar">
            {(() => {
              const registrationType = localStorage.getItem('registrationType');
              const expirationDate = localStorage.getItem('expirationDate');
              const daysLeft = expirationDate ? Math.ceil((new Date(expirationDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)) : null;
              return registrationType ? (
                <Box style={{ display: 'none', alignItems: 'center', gap: '8px', marginRight: '12px' }}>
                  {daysLeft !== null && (
                    <span style={{ background: '#e53935', color: '#fff', fontSize: '12px', fontWeight: 600, padding: '4px 10px', borderRadius: '12px' }}>
                    Free Registration Expires in: {daysLeft} days
                    </span>
                  )}
                </Box>
              ) : null;
            })()}
            <NotificationBar openFeedbackModel={openFeedbackModel} />
            <Box className="mobile-language-header-new">
              <Box component="ul" className="right-menus-new">
                <Box component="li" className="">
                  <LanguageSwitcher/>
                </Box>
              </Box>
            </Box>
          </Box>}
        </>
      )}
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        BackdropProps={{ style: { backgroundColor: "transparent" } }}
        className={classesList.modal}
      >
        <Box className={classesList.box}>
          <Box className={classesList.inside}>
            <NotificationScreen
              refresh={refresh}
              setRefresh={() => setRefresh(!refresh)}
            />
          </Box>
        </Box>
      </Modal>
    </Toolbar>
  );
}

const styles = (theme) => ({
  box: {
    backgroundColor: "white",
    position: "absolute",
    top: "65px",
    right: "70px",
    boxShadow: theme.shadows[4],
  },
  inside: {
    overflowY: "scroll",
    maxHeight: "570px",
    width: "460px",
  },
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  headerCourseNameBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '0px 10px',
    "@media (max-width: 500px)": {
      padding: '0px 4px',
      gap: '4px'
    }
  },
  courseNameText: {
    fontSize: '18px',
    fontWeight: 500,
    color: '#202020'
  },
  reportsHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px"
  }
});

export default CHeaderBarContent;
